import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Copy, Check } from 'lucide-react';
import { toast } from 'sonner';

export const ReferralCode = ({ code }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    toast.success('Referral code copied!');
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="flex items-center gap-2">
      <div
        className="font-mono text-lg font-medium tracking-wide bg-gray-100 border border-gray-300 rounded-md px-4 py-3 text-center flex-1"
        data-testid="referral-code-display"
      >
        {code}
      </div>
      <Button
        onClick={handleCopy}
        variant="outline"
        size="icon"
        className="h-[50px] w-[50px]"
        data-testid="copy-referral-code-button"
      >
        {copied ? <Check className="w-5 h-5 text-green-600" /> : <Copy className="w-5 h-5" />}
      </Button>
    </div>
  );
};